// import { ListResponseModel } from ".";
import { Appliance } from "../model/appliance";
import { ApplianceCategory } from "../model/appliance-category";
import { apiSlice } from "../stores/base/api-slice";

// interface FormData {
// 	Image: File;
// 	Name: string;
// }

const applianceCategoryEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getApplianceCategories: builder.query<Array<ApplianceCategory>, { query?: string } | void>({
            providesTags: ["ApplianceCategory"],
            query: (params) => ({
                url: params?.query 
                    ? `/appliance-category/all?Search=${params.query}`
                    : '/appliance-category/all',
                method: "GET",
            }),
        }),
		createApplianceCategory: builder.mutation<any, FormData>({
			invalidatesTags: ["ApplianceCategory"],
			query: formData => ({
				url: "/appliance-category",
				method: "POST",
				body: formData,
			}),
		}),
		updateApplianceCategory: builder.mutation<any, FormData>({
			invalidatesTags: ["ApplianceCategory"],
			query: formData => ({
				url: "/appliance-category",
				method: "PUT",
				body: formData,
			}),
		}),
		deleteApplianceCategory: builder.mutation<any, {id : string}>({
			invalidatesTags: ["ApplianceCategory"],
			query: ({id}:{id : string}) => ({
				url: `/appliance-category/${id}`,
				method: "DELETE",
			}),
		}),
		getApplianceCategoryById: builder.query<Array<Appliance>, { id: string }>({
			providesTags: ["ApplianceCategory"],
			query: ({ id }: { id: string }) => ({
				url: `/appliance-category/${id}`,
				method: "GET",
			}),
		}),
	}),
});

export const {
	useLazyGetApplianceCategoriesQuery,
	useLazyGetApplianceCategoryByIdQuery,
	useCreateApplianceCategoryMutation,
	useDeleteApplianceCategoryMutation,
	useUpdateApplianceCategoryMutation,
} = applianceCategoryEndpoints;
